import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

const DISCOVER_PAGE_ID = 'discover';

export const loadData = (params, search, config) => dispatch => {
  const pageId = params.pageId;
  // /p/discover redirects to /trending, which loads its own Discover data.
  if (pageId === DISCOVER_PAGE_ID) {
    return Promise.resolve();
  }

  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent));
};
